import { render, staticRenderFns } from "./SingleSelectionRate.vue?vue&type=template&id=fab2c9a2"
import script from "./SingleSelectionRate.vue?vue&type=script&lang=js"
export * from "./SingleSelectionRate.vue?vue&type=script&lang=js"
import style0 from "./SingleSelectionRate.vue?vue&type=style&index=0&id=fab2c9a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports